import moment from 'moment';
import _ from 'lodash';

import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { BaseSchema } from '../baseSchema';

export const Payments = new Mongo.Collection('payments');

Payments.attachRoles('payments');

export const Payment = new SimpleSchema([{
	type: {
		type: String,
		label: "Type",
	},
	montant: {
		type: String,
		label: "Montant"
	},
	reservation: {
		type: String,
		label: "Identifiant de la réservation"
	},
	informations: {
		type: String,
		label: "Informations",
		optional: true
	}
  }, BaseSchema]);

Payments.attachSchema(Payment);

// Dbs methods : 

Meteor.methods({
	'payments.insert'(attributes) {
		Payments.insert(attributes); 
	},
	'payments.remove'(_id) {
		Payments.remove(_id);
	}
});

// Helpers :
Payments.helpers({
});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/reservations/payments.js
 **/